import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { QuotaInputData } from "./../models/cm-model";
import { UserData } from '../shared/models/user.model';
import {SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService,SohoDatePickerComponent} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { AuthHelper } from './../services/authHelper';
import { arePayCurvesEnabled } from './../services/fiscal-year.helper';

@Component({
  selector: 'app-edit-quota-input',
  templateUrl: './edit-quota-input.component.html',
  styleUrls: ['./edit-quota-input.component.css'],
  providers: [DatePipe]
})
export class EditQuotaInputComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  @ViewChild(SohoDatePickerComponent, { static: true }) datepicker?: SohoDatePickerComponent;
  placeholder!: ViewContainerRef;
  uniqueID: string = "0";
  emailAddress!: string;
  userData = new UserData();

  public normalTooltipText = ResponseMsg.SubCategoryInfo;
  public ManagerMembership = ResponseMsg.ManagerMembership;
  public UserMembership = ResponseMsg.UserMembership;
  public ProductToolTip = ResponseMsg.ProductToolTip;
  public CategoryToolTip = ResponseMsg.CategoryToolTip;
  public SubCategoryToolTip = ResponseMsg.SubCategoryToolTip;
  public ShortDescToolTip = ResponseMsg.ShortDescToolTip;
  public DescriptionToolTip = ResponseMsg.DescriptionToolTip;
  public ApproverIDToolTip = ResponseMsg.ApproverIDToolTip;
  public ProjectTitle = "Edit Quota Input";

  isvalid!: boolean;
  public disableAll: boolean = false;

  // Pay curves only exist from environment.payCurveMinFiscalYear onwards, so
  // the pay curve fields are not rendered for earlier fiscal years.
  public showPayCurves: boolean = arePayCurvesEnabled();

  public getTodaysDate!: Date;
  public getDate?: string;

  message = 'Loading...';
  delay = 5;
  transparentOverlay = false;

  public context = this;
  public ObjResponse: any;

  constructor(private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: QuotaInputData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private authhelper: AuthHelper,
    private datePipe: DatePipe,
    private notificationService: SohoNotificationService) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    if(this.route)
    {
      this.route.queryParams.subscribe(params => {
        this.uniqueID = params["uniqueid"];
      });
    }
    //this.LoadBusyIndicator();
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData!= null && this.userData!=undefined) {     
      this.emailAddress = this.userData.Email;
      this.GetQuotaInput();
    }  

  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  onChange(event: SohoDatePickerEvent) {
    
    console.log('DatePickerDemoComponent.onChange: type=' + event.target, 'Has originalEvent: ' + (event.originalEvent !== undefined));
  }
  GetQuotaInput() {
    this.start();
    this.capacityModelService.GetQuotaInputForEdit(this.uniqueID).subscribe(
      quotainput => {
        //console.log(quotainput);
        this.model = quotainput;
        let startDateYear = new Date(this.model.planstartdate).getFullYear();
        this.model.planenddate = (this.model.planenddate != null) ?  this.datePipe.transform(this.model.planenddate,'MM/dd/yyyy')!: "12/31/".concat(startDateYear.toString())  ;
        this.model.planstartdate =this.datePipe.transform(this.model.planstartdate,'MM/dd/yyyy')!;
        //this.model.planenddate =this.datePipe.transform(this.model.planenddate,'MM/dd/yyyy')!;
        this.disableAll = true;
        this.stop();
      },
      (error: Response) => {
        this.AddErrorDetails(error);
        this.stop();
      }
    );
  }
  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message:
        "Can edit the already loaded territory budgets alloted using this page.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
    //$("#btnBusy").trigger('click');
  }
  LoadBusyIndicator() {
    setTimeout((f: any) => this.busyIndicator!.activated = true, 50);
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  Cancel() {
    $("#divAddProject").removeClass("is-selected");
    this.router.navigate(["QuotaInput"]);
  }
  ShowAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              this.ResetModel();
              this.router.navigate(["QuotaInput"]);
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ResetModel() {
    let fields: string[] = [
      "planstartdate", "planenddate"
    ];
    for (let objField of fields) {
      $("#" + objField).removeError();
    }

    this.model.uniqueid = 0;
    this.model.commentsadded = '';
    this.model.detaileduniqueid = 0;
    this.model.employeeid = '';
    this.model.employeename = '';
    this.model.finaliseduniqueid = 0;
    this.model.fiscalyear = '';
    this.model.gicrejected = false;
    this.model.lob = "";
    this.model.perpetuallogomultiplier = 0;

    this.model.perpetualmultiplier = 0;
    this.model.plantype = '';
    this.model.processed = false;
    this.model.saaslogomultiplier = 0;
    this.model.saasmultipliergt3years = 0;
    this.model.saasmultipliergt2lt3years = 0;
    this.model.saasmultipliergt1lt2years = 0;

    this.model.territorygroup = '';
    this.model.totalquota = 0;
    this.model.totalquotausd = 0;
    this.model.variablepay = 0;
    this.model.variablepaycurrency = '';
    this.model.variabletype = '';

    this.model.createdby = "";
    this.model.updatedby = "";
  }
  UpdateProject() {

    this.model.updatedby = this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress;
    this.isvalid = true;
let planenddate=this.datePipe.transform(this.model.planenddate, 'MM/dd/yyyy');
    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['planstartdate', 'planenddate']);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    if(this.isvalid && Date.parse(this.model.planstartdate)>=Date.parse(this.model.planenddate))
    {
    this.ShowAlert("Plan start date should always be less than plan end date", ResponseMsg.ErrorMsg);
    this.isvalid  =false;
  }
    if (this.isvalid) {
      //this.model.commentsadded='testing';
      this.start();
      this.capacityModelService.UpdateQuotaInputs(this.model).subscribe(
        response => {
          this.stop();
          
          if (response.status == 200) {
            this.ShowAlert("Quota Input details updated successfully.", ResponseMsg.Success);
          } else {
            this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
          }
        },
        (error: Response) => {
          this.stop();
          this.AddErrorDetails(error);
          this.ShowAlert("Error Occured while updating Quota Inputs.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }
  AddErrorDetails(error: Response) {
    // this.appError.Ok = error.ok;
    // this.appError.Status = error.status;
    // this.appError.StatusText = error.statusText;
    // this.appError.URL = error.url;
    // this.appError.Body = error.json()["ExceptionMessage"];
    // this.projectService.LogErrorDetails(this.appError).subscribe(success => {
    //   console.log("Error details");
    // });
  }
}
